import {Component, inject, OnInit} from '@angular/core';
import {OidcSecurityService} from "angular-auth-oidc-client";
import {IconPreloaderService} from "./shared/services/icon-preloader.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'Mojito BI';
  public readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly iconPreloader = inject(IconPreloaderService);

  ngOnInit() {
    if (!window.location.href.includes('auth')) {
      localStorage.setItem('currentPathname', window.location.pathname);
    }

    // Inicializar la precarga de iconos
    this.iconPreloader.preloadCommonIcons();
  }
}
